import Constants from './Constants';

export interface MenuItem {
    name: string;
    href: string;
    section: string;
    roles: string[];
    extra?: string[];
}

export const MenuItems = [
    {
        name: 'Classroom Dashboard',
        href: '/user/dashboard',
        section: 'Home',
        roles: Constants.ALL_ROLES,
    },
    {
        name: 'Resource Dashboard',
        href:
            window.location.hostname === 'localhost'
                ? 'http://localhost:5174'
                : 'https://teacher.paradigmmath.com',
        section: 'Home',
        roles: Constants.ALL_NON_STUDENT_ROLES,
    },
    {
        name: 'Student Exam View',
        href: '/studentExamView/attempt/new',
        section: 'Home',
        roles: [Constants.ROLES.SUPER_ADMIN],
    },

    {
        name: 'Users',
        href: '/rostering/users',
        section: 'Rostering',
        roles: [Constants.ROLES.SUPER_ADMIN],
    },
    {
        name: 'Districts',
        href: '/rostering/districts',
        section: 'Rostering',
        roles: Constants.ALL_ADMIN_ROLES,
    },
    {
        name: 'Schools',
        href: '/rostering/schools',
        section: 'Rostering',
        roles: Constants.ALL_ADMIN_ROLES,
    },
    {
        name: 'Classes',
        href: '/rostering/classes',
        section: 'Rostering',
        roles: Constants.ALL_NON_STUDENT_ROLES,
    },
    {
        name: 'Nightly Sync',
        href: '/rostering/nightlySync',
        section: 'Rostering',
        roles: [Constants.ROLES.SUPER_ADMIN],
    },

    {
        name: 'Question Editor',
        href: '/questions/createEditQuestion',
        section: 'Questions',
        roles: [Constants.ROLES.SUPER_ADMIN],
    },
    {
        name: 'View Questions',
        href: '/questions/viewQuestions',
        section: 'Questions',
        roles: [Constants.ROLES.SUPER_ADMIN],
    },
    {
        name: 'Dynamic Sandbox',
        href: '/questions/dynamicSandbox',
        section: 'Questions',
        roles: [Constants.ROLES.SUPER_ADMIN],
    },

    {
        name: 'Exam Editor',
        href: '/examsAdmin/createEditExam',
        section: 'Exams - Admin',
        roles: [Constants.ROLES.SUPER_ADMIN],
    },
    {
        name: 'View Exams',
        href: '/examsAdmin/viewExams',
        section: 'Exams - Admin',
        roles: [Constants.ROLES.SUPER_ADMIN],
    },
    {
        name: 'Standards',
        href: '/examsAdmin/standards',
        section: 'Exams - Admin',
        roles: [Constants.ROLES.SUPER_ADMIN],
    },

    {
        name: 'Your Assessments',
        href: '/exams/viewExamAttempts',
        section: 'Assessments',
        roles: [Constants.ROLES.SUPER_ADMIN, Constants.ROLES.STUDENT],
    },
    {
        name: 'Assign a Test',
        href: '/exams/examAssignments',
        section: 'Assessments',
        roles: Constants.ALL_NON_STUDENT_ROLES,
    },
    {
        name: 'Dynamic Quiz Generator - Admin',
        href: '/exams/dynamicQuizGenerator',
        section: 'Assessments',
        // roles: Constants.ALL_NON_STUDENT_ROLES,
        roles: [Constants.ROLES.SUPER_ADMIN],
    },
    {
        name: 'Handscore',
        href: '/exams/handscoreQuestions',
        section: 'Assessments',
        roles: Constants.ALL_NON_STUDENT_ROLES,
    },
    {
        name: 'Attempt Details',
        href: '/exams/attemptDetails',
        section: 'Assessments',
        roles: Constants.ALL_NON_STUDENT_ROLES,
    },

    {
        name: 'Online Practice (coming soon)',
        href: '#',
        section: 'BTBF',
        roles: Constants.ALL_ROLES,
        extra: ['disabled'],
    },

    {
        name: 'Class Matrix',
        href: '/reports/classMatrix',
        section: 'Reports',
        roles: Constants.ALL_NON_STUDENT_ROLES,
    },
    {
        name: 'Class Summary',
        href: '/reports/classSummary',
        section: 'Reports',
        roles: Constants.ALL_NON_STUDENT_ROLES,
    },
    {
        name: 'Exam History',
        href: '/reports/examHistory',
        section: 'Reports',
        roles: Constants.ALL_NON_STUDENT_ROLES,
    },
    {
        name: 'Exam Summary',
        href: '/reports/examSummary',
        section: 'Reports',
        roles: Constants.ALL_NON_STUDENT_ROLES,
    },
    {
        name: 'Standards Report',
        href: '/reports/standards',
        section: 'Reports',
        roles: Constants.ALL_NON_STUDENT_ROLES,
    },
    {
        name: 'Status Report',
        href: '/reports/statusReport',
        section: 'Reports',
        roles: Constants.ALL_NON_STUDENT_ROLES,
    },
    {
        name: 'Student History',
        href: '/reports/studentHistory',
        section: 'Reports',
        roles: Constants.ALL_ROLES,
    },
    {
        name: 'Submission History',
        href: '/reports/submissionHistory',
        section: 'Reports',
        roles: Constants.ALL_NON_STUDENT_ROLES,
    },
    {
        name: 'Math Tools',
        href: 'https://paradigmmath.com/mathtools/index.php?door=03058597',
        section: 'Math Tools',
        roles: Constants.ALL_ROLES,
        extra: ['external'],
    },
    {
        name: 'Interactive Book',
        href: 'https://interactivebook.paradigmmath.com/SSOAuth/BridgeLoginFromCookie',
        section: 'Interactive Book',
        roles: Constants.ALL_ROLES,
    },
    {
        name: 'Practice',
        href: 'https://practice.paradigmmath.com',
        section: 'Practice',
        roles: Constants.ALL_ROLES,
    },
];
